import React from "react";
import { Counterparty } from "@common/types/counterparty";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    value: string;
    counterparties: Counterparty[];
}

export const RuleCounterpartyAction: React.FC<Props> = ({
    value,
    counterparties,
}) => {
    const counterparty = counterparties.find((c) => c.id === value);

    if (!counterparty) {
        return null;
    }

    return (
        <RuleTagRow
            label="Assign counterparty"
            type="action"
            values={[counterparty.name]}
        />
    );
};
